import { createAsyncAction, createAction } from 'redux-promise-middleware-actions';
import { addAsyncActionPostfixes } from '../utils/actionTypeCreator';
import { tneAxiosClient } from '../api/apiSettings';

export const types = {
  ...addAsyncActionPostfixes({
    GET_PARTICULAR_TIMESHEET: 'GET_PARTICULAR_TIMESHEET',
    CHECK_UNCHECK: 'CHECK_UNCHECK',
    CREATE_NEW_TIMESHEET: 'CREATE_NEW_TIMESHEET',
    GET_PENDING_TANDE_COUNTS: 'GET_PENDING_TANDE_COUNTS',
    GET_TANDE_COUNTS_CONTRACTOR: 'GET_TANDE_COUNTS_CONTRACTOR',
    GET_TIMESHEET_APPROVER_REQUEST: 'GET_TIMESHEET_APPROVER_REQUEST',
    GET_TIMESHEET_VALIDATION: 'GET_TIMESHEET_VALIDATION',
    SAVE_COMMENT: 'SAVE_COMMENT',
    UPDATE_COMMENT: 'UPDATE_COMMENT'
  }),
  UPDATE_GENERAL_DATA: 'UPDATE_GENERAL_DATA',
  UPDATE_TIMESHEET: 'UPDATE_TIMESHEET',
  DELETE_TIMESHEET_LINE: 'DELETE_TIMESHEET_LINE',
  RESTORE_DELETED_TIMESHEET_LINE: 'RESTORE_DELETED_TIMESHEET_LINE',
  CLEAR_TIMESHEET_DATA: 'CLEAR_TIMESHEET_DATA',
  CHANGE_STATUS: 'CHANGE_STATUS',
  CHANGE_PERDIEM: 'CHANGE_PERDIEM',
  CHANGE_PART_OF_PERDIEM: 'CHANGE_PART_OF_PERDIEM'
};

export const getTimesheet = createAsyncAction(types.GET_PARTICULAR_TIMESHEET, (timesheetId, userId) => {
  return tneAxiosClient.get(`v1/timesheet?timesheetId=${timesheetId}`).then((res) => res.data.Data);
});

export const updateTimesheet = createAction(types.UPDATE_TIMESHEET, (timesheet) => ({ Data: timesheet }));

export const deleteLineById = createAction(types.DELETE_TIMESHEET_LINE, (id) => ({ id }));

export const restoreDeletedTimesheetLine = createAction(types.RESTORE_DELETED_TIMESHEET_LINE, (line) => ({ line }));

export const updateGeneralData = createAction(types.UPDATE_GENERAL_DATA, (prop, value) => ({
  Data: { prop, value }
}));

export const checkUncheckAllRows = createAction(types.CHECK_UNCHECK, (timesheets) => timesheets);

export const addNewTimesheet = createAction(types.CREATE_NEW_TIMESHEET);

export const clearTimesheet = createAction(types.CLEAR_TIMESHEET_DATA);

export const saveComment = createAsyncAction(types.SAVE_COMMENT, (comment, timesheetId) => {
  return tneAxiosClient
    .post(`v1/approver-comment`, { TimesheetId: timesheetId, Reason: comment })
    .then((res) => res.data.Data);
});

export const updateComment = createAsyncAction(types.UPDATE_COMMENT, (comment, commentId) => {
  return tneAxiosClient
    .put(`v1/approver-comment`, { Id: commentId, Reason: comment })
    .then(() => ({ comment, commentId }));
});

export const getTandEPendingCounts = createAsyncAction(types.GET_PENDING_TANDE_COUNTS, () => {
  return tneAxiosClient.get(`v1/get-tne-count`).then((res) => res.data.Data);
});

export const getTandECountsContractor = createAsyncAction(types.GET_TANDE_COUNTS_CONTRACTOR, () => {
  return tneAxiosClient.get(`v1/get-tne-count-contractor`).then((res) => res.data.Data);
});

export const getTimesheetApproverRequest = createAsyncAction(
  types.GET_TIMESHEET_APPROVER_REQUEST,
  (notificationType) => {
    return tneAxiosClient.get(`v1/get-requested-approvers`).then(
      (res) => {
        return {
          data: res?.data?.Data,
          notificationType
        };
      },
      (error) => {
        throw error;
      }
    );
  }
);

export const changeStatus = createAction(types.CHANGE_STATUS, (status) => status);

export const changePerDiem = createAction(types.CHANGE_PERDIEM, (newPerDiem) => newPerDiem);

export const changePartOfPerDiem = createAction(types.CHANGE_PART_OF_PERDIEM, (newPerDiemPart) => newPerDiemPart);

export const getTimeExpenseValidation = createAsyncAction(types.GET_TIMESHEET_VALIDATION, (companyId, jobId) => {
  return tneAxiosClient.get(`v1/tande-validation?compnayId=${companyId}&jobId=${jobId}`).then((res) => res.data.Data);
});
